export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10936.a30062b9.jpg";